
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import OptimizedImage from "@/components/ui/optimized-image";

interface LoanTypeCardProps {
  title: string;
  description: string;
  detailText: string;
  icon: LucideIcon;
  linkPath: string;
  imagePath?: string;
}

const LoanTypeCard = ({ title, description, detailText, icon: Icon, linkPath, imagePath }: LoanTypeCardProps) => {
  return (
    <Card className={`relative overflow-hidden bg-white hover:shadow-lg transition-shadow ${imagePath ? 'text-white' : ''}`}>
      {imagePath && (
        <div className="absolute inset-0 z-0">
          <OptimizedImage 
            src={imagePath} 
            alt={title} 
            className="w-full h-full"
            objectFit="cover"
            fill={true}
            quality={75}
          />
          <div className="absolute inset-0 bg-blue-900/60" />
        </div>
      )}
      
      <CardHeader className={`pb-2 ${imagePath ? 'relative z-10' : ''}`}>
        <div className="flex items-center justify-between">
          <CardTitle className={`text-xl ${imagePath ? 'text-white' : 'text-blue-700'}`}>{title}</CardTitle>
          <div className={`${imagePath ? 'bg-white/20' : 'bg-blue-100'} p-2 rounded-full transition-transform duration-300 hover:scale-110`}>
            <Icon className={`${imagePath ? 'text-white' : 'text-blue-600'} h-6 w-6`} />
          </div>
        </div>
        <CardDescription className={imagePath ? 'text-blue-100' : ''}>{description}</CardDescription>
      </CardHeader>
      <CardContent className={imagePath ? 'relative z-10' : ''}>
        <p className={`mb-4 h-16 ${imagePath ? 'text-blue-50' : 'text-gray-700'}`}>
          {detailText}
        </p>
        <Link 
          to={linkPath} 
          className={`font-medium hover:underline inline-flex items-center group ${imagePath ? 'text-white' : 'text-blue-600'}`}
          aria-label={`Lue lisää lainasta: ${title} - ${description}`}
          title={`Katso tarkemmat tiedot lainasta: ${title}`}
        >
          Lue lisää {title.toLowerCase()} vaihtoehdoista
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 group-hover:ml-2 transition-all" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
          </svg>
        </Link>
      </CardContent>
    </Card>
  );
};

export default LoanTypeCard;
